//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'

import Select from 'components/Shared/Select/Index'
import Badge from 'components/Shared/Badge/Index'

import { customIsEqual } from './utils'

const PORTAL_Z_INDEX = 10001

const SelectWithBadgesField = ({
  name, placeholder, disabled, validate, isInModal, isLoading, options,
}) => {
  const options_ = []
  const iconComponentsMap = {}
  options.forEach(option => {
    options_.push({
      value: option.value,
      label: '',
    })
    iconComponentsMap[option.value] = (
      <Badge margin='0 4px 0 0'>{option.label}</Badge>
    )
  })

  return (
    <Field
      allowNull
      name={name}
      isEqual={customIsEqual}
      validate={validate}
    >
      {({ input, meta }) => {
        return (
          <Select
            small
            isLoading={isLoading}
            value={input.value}
            onChange={input.onChange}
            options={options_}
            placeholder={placeholder}
            usePortal={isInModal ? true : undefined}
            portalZindex={isInModal ? PORTAL_Z_INDEX : undefined}
            disabled={disabled}
            iconComponentsMap={iconComponentsMap}
          />
        )
      }}
    </Field>
  )
}

SelectWithBadgesField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  validate: PropTypes.func,
  isInModal: PropTypes.bool,
  isLoading: PropTypes.bool,
  options: PropTypes.array,
}

export default SelectWithBadgesField
